var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-feedback" }, [
    _c(
      "button",
      {
        staticClass: "viq-feedback__btn",
        class: {
          "viq-feedback__btn--active-up": _vm.rating === "up",
          "viq-feedback__btn--disabled": !!_vm.rating && _vm.rating !== "up",
        },
        attrs: { disabled: !!_vm.rating, title: "Helpful" },
        on: { click: _vm.handleUp },
      },
      [
        _c(
          "svg",
          {
            attrs: {
              width: "14",
              height: "14",
              viewBox: "0 0 20 20",
              fill: "currentColor",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z",
              },
            }),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "viq-feedback__btn",
        class: {
          "viq-feedback__btn--active-down": _vm.rating === "down",
          "viq-feedback__btn--disabled": !!_vm.rating && _vm.rating !== "down",
        },
        attrs: { disabled: !!_vm.rating, title: "Not helpful" },
        on: { click: _vm.handleDown },
      },
      [
        _c(
          "svg",
          {
            staticStyle: { transform: "rotate(180deg)" },
            attrs: {
              width: "14",
              height: "14",
              viewBox: "0 0 20 20",
              fill: "currentColor",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z",
              },
            }),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _vm.rating === "up"
      ? _c("span", { staticClass: "viq-feedback__thanks" }, [_vm._v("Thanks!")])
      : _vm._e(),
    _vm._v(" "),
    _vm.reason
      ? _c("span", { staticClass: "viq-feedback__reason-label" }, [
          _vm._v("\n    " + _vm._s(_vm.reasonLabel) + "\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showReasons
      ? _c(
          "div",
          { staticClass: "viq-feedback__reasons" },
          _vm._l(_vm.reasons, function (r) {
            return _c(
              "button",
              {
                key: r.value,
                staticClass: "viq-feedback__pill",
                on: {
                  click: function ($event) {
                    return _vm.handleReason(r.value)
                  },
                },
              },
              [_vm._v(_vm._s(r.label))]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }